import React from 'react';
import { FsInput } from '@finalsite/wc-react';
import { getHtmlId, getHtmlName } from '../utils/CustomFieldHelpers';

export const TextField = ({ field, name, ref, id, onChange }) => {
  return <FsInput
    name={name}
    id={id}
    ref={ref}

    label={field.rendered_prompt}
    value={field.value}
    required={field.required_on_form || field.has_required_children}
    hint={field.rendered_explanation}
    description={field.rendered_explanation}
    onChange={onChange}
    errorMessage={null /* TODO : field.errorMessage */}
    type="text"
    className="fs-text-field"
  />
};
